export default "<div class=\"text-center m-5\">\r\n    <button type=\"button\" class=\"btn btn-primary\" (click)=\"goBack()\">Volver</button>\r\n</div>\r\n"